module.exports = __webpack_public_path__ + "img/romantic.1fd5749.webp";